import { Navigate, useSearchParams } from 'react-router'
import { ROUTE_DOCUMENTS } from '@klear/constants'
import type { DocumentStatus } from '@klear/schema/documents'

const REVIEWING = { status: 'needs_review' satisfies DocumentStatus }

const FILTERS_OF_TRIAGE_TAB: Record<string, Record<string, string>> = {
  todo: REVIEWING,
  ready: REVIEWING,
  questions: REVIEWING,
  blocked: REVIEWING,
  manual: REVIEWING,
  filed: { status: 'filed' satisfies DocumentStatus },
  dismissed: { status: 'dismissed' satisfies DocumentStatus }
}

export default function DocumentTriageRedirect() {
  const [params] = useSearchParams()
  const next = new URLSearchParams(FILTERS_OF_TRIAGE_TAB[params.get('tab') ?? 'todo'] ?? REVIEWING)
  const trader = params.get('trader')
  const search = params.get('search')
  if (trader !== null && trader !== '') next.set('trader', trader)
  if (search !== null && search !== '') next.set('search', search)
  return <Navigate to={`/${ROUTE_DOCUMENTS}?${next.toString()}`} replace />
}
